var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"tito-widget-button",on:{"click":_vm.open}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.buttonLabelOrDefault))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }